module.exports = __webpack_public_path__ + "2e34bdde.jpg";